import React, { useContext } from 'react';
import SearchForm from './SearchForm';
import { DomainSearchContainer } from './DomainSearchContainer';
import { AudioResults } from './AudioResults';
import { AlgoliaSearchContainer } from './AlgoliaSearchContainer';
import { PlaySearchContainer } from './PlaySearchContainer';
import { searchContextStore } from '../search/SearchContextProvider';

export const SearchContainer = ({
  isWebview,
  algoliaDomainIndex,
  algoliaIndex,
}) => {
  const { state: searchContext } = useContext(searchContextStore);

  return (
    <>
      {/* the form */}
      <SearchForm />

      {/* play results - if active */}
      {searchContext.searchConfig.playSearch.active && <PlaySearchContainer />}

      {/* domain search results - if active */}
      {searchContext.searchConfig.domainSearch.active && (
        <DomainSearchContainer
          isWebview={isWebview}
          algoliaIndex={algoliaDomainIndex}
        />
      )}

      {/* audio search results - if active */}
      {searchContext.searchConfig.audioSearch.active && <AudioResults />}

      {/* algolia search results - if active*/}
      {searchContext.searchConfig.algoliaSearch.active && (
        <AlgoliaSearchContainer
          isWebview={isWebview}
          algoliaIndex={algoliaIndex}
        />
      )}
    </>
  );
};

export default SearchContainer;
